import { render, staticRenderFns } from "./eventmodel.vue?vue&type=template&id=1d9c5452&scoped=true&"
import script from "./eventmodel.vue?vue&type=script&lang=js&"
export * from "./eventmodel.vue?vue&type=script&lang=js&"
import style0 from "./eventmodel.vue?vue&type=style&index=0&id=1d9c5452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9c5452",
  null
  
)

export default component.exports